<template>
    <div>
        <!--class="grid with-grid-lines page--light is-chrome"-->
        <encabezado></encabezado>
        <breadcrum :titulo='titulo' :texto='texto'></breadcrum>
        <div style="padding-left:10%">
            <buscador></buscador>
     
            <div class="module-info" v-if="hayDatosOrden">
                <estado></estado>
                <acciones></acciones>
                <operaciones></operaciones>
                <datosDispositivo></datosDispositivo>
                <datosCliente></datosCliente>
            </div>
        </div>
        <!--<div class="module-info" v-if="esPruebas">
        <p class="text--s">Acceso a movistar <router-link class="text--s enlace" to="/movistar/informacion">AQUI</router-link></p>
        <p class="text--s">Acceso a O2 <router-link class="text--s enlace" to="/O2/informacion">AQUI</router-link></p>
        <p class="text--s">Acceso a catalogo <router-link class="text--s enlace" to="/catalogo">AQUI</router-link></p>
        <p class="text--s">Acceso a condiciones <router-link class="text--s enlace" to="/condiciones">AQUI</router-link></p>
        <p class="text--s">Acceso a consultas <router-link class="text--s enlace" to="/consultas">AQUI</router-link></p>
        <p class="text--s">Acceso a empresaCR <router-link class="text--s enlace" to="/empresaCR">AQUI</router-link></p>
        <p class="text--s">Acceso a empresas <router-link class="text--s enlace" to="/empresas">AQUI</router-link></p>
        <p class="text--s">Acceso a empresasCR <router-link class="text--s enlace" to="/empresasCR">AQUI</router-link></p>
        <p class="text--s">Acceso a empresaSR <router-link class="text--s enlace" to="/empresaSR">AQUI</router-link></p>
        <p class="text--s">Acceso a info-clientes <router-link class="text--s enlace" to="/info-clientes">AQUI</router-link></p>
        <p class="text--s">Acceso a particularCR <router-link class="text--s enlace" to="/particularCR">AQUI</router-link></p>
        <p class="text--s">Acceso a particulares <router-link class="text--s enlace" to="/particulares">AQUI</router-link></p>
        <p class="text--s">Acceso a particularSR <router-link class="text--s enlace" to="/particularSR">AQUI</router-link></p>
        <p class="text--s">Acceso a recoverPasswordParticularCR <router-link class="text--s enlace" to="/recoverPasswordParticularCR">AQUI</router-link></p>
        <p class="text--s">Acceso a reparacion <router-link class="text--s enlace" to="/reparacion">AQUI</router-link></p>
        <p class="text--s">Acceso a sat-clientesmovistar <router-link class="text--s enlace" to="/sat-clientesmovistar">AQUI</router-link></p>
    </div>-->
        <pie></pie>
    </div>
</template>

<script>
    import breadcrum from '@/components/breadcrum'
    import encabezado from '@/components/newEncabezado'
    import buscador from '@/components/buscador'
    import acciones from '@/components/consultas/acciones'
    import estado from '@/components/consultas/estado'
    import datosCliente from '@/components/consultas/datosCliente'
    import datosDispositivo from '@/components/consultas/datosDispositivo'
    import operaciones from '@/components/consultas/operaciones'
    import pie from '@/components/newPie'

    export default {
        components: {
            encabezado,
            breadcrum,
            buscador,
            acciones,
            estado,
            datosCliente,
            datosDispositivo,
            operaciones,
            pie
        },

        data: () => ({
            name: 'index',
            texto: 'Si ya tienes una referencia de orden de reparación, puedes obtener datos sobre el estado de la reparación con el buscador',
            titulo: 'Buscador'
        }),
        computed: {
            hayDatosOrden() {
                if (typeof this.$bus.pConsulta.datosOrden !== 'undefined' && Object.keys(this.$bus.pConsulta.datosOrden).length !== 0)
                    return true
                else
                    return false
            },
            esPruebas() {
                return window.location.href.includes("localhost") || window.location.href.includes("test")
            }
        },
        created() { //Para pruebas
            //if (window.location.href.includes("test")) this.$router.push('/particulares')
        }
    }
</script>